import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dialog, IconButton } from 'react-toolbox';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import ColoredButton from 'components/ColoredButton';
import { clearValidation, clearValidationErrors, lrrpCreate, updatePhaseTask, uploadDocument } from 'actionCreators';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import './displayFeedStyling.css';
import S from 'modal.scss';
import styles from 'styles/input.scss';
import Dropzone from 'react-dropzone';
import dropStyles from 'dropzoneStyles.scss';


class DeliveredModal extends Resetter(Validator(React.Component)) {
  static VALIDATIONS = { imgsTaken: 'This field is required' }

  constructor(props) {
    super(props);
    this.state = { imgsTaken: [], errorMessage: false };
  }

  handlePhotoSubmit = () => {
    const { phase: { id }, task: { slug } } = this.props;
    if (this.state.imgsTaken.length === 0) this.setState({ errorMessage: true });
    else {
      const preppedImg = this.state.imgsTaken;
      if (!this.validate()) return;
      const formData = new FormData();
      preppedImg.map((img) => {
        formData.append('document_upload[assets][][asset]', img);
        formData.append('document_upload[assets][][document_name]', `DeliveryCompletePhoto${img.lastModified}`);
        formData.append('document_upload[assets][][document_type]', img.type);
        return null;
      });
      this.props.uploadDocument(formData, id)
        .then(() => this.props.updatePhaseTask(id, slug, { task: { status: 'complete' } }))
        .then(() => this.handleClose())
        .then(() => window.location.reload())
        .catch(result => this.setState({ sendError: true, errors: result.payload.errors }));
    }
  }

  handleClearPhotos = () => this.setState({ imgsTaken: [] })

  onDrop = (files) => {
    const stateArr = this.state.imgsTaken;
    for (let index = 0; index < files.length; index += 1) {
      const element = files[index];
      stateArr.push(element);
    }
    this.setState({ imgsTaken: stateArr });
  };

  mapUploadedPhoto = (file, index) =>
    (<a target="_blank" rel="noopener noreferrer" key={index} href={file.preview}>
      <img style={{ width: '100%' }} src={file.preview} key={file.preview} alt={file.name} />
    </a>);

  render = () => {
    const { active, errors: serverErrors } = this.props;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Delivery Picture</h5>
      <div>
        <h6>A picture is required upon delivery</h6>
        <br />
        <Dropzone className={dropStyles.uploadFile} onDrop={this.onDrop}>
          <ColoredButton
            color="blue"
          >{this.state.imgsTaken.length > 0 ? 'Upload another photo' : 'Upload a photo'}
          </ColoredButton>
        </Dropzone>
        <div>
          {this.state.imgsTaken.length > 0 ? this.state.imgsTaken.map(file => this.mapUploadedPhoto(file)) : ''}
        </div>
        <div className={S.btnContainer}>
          {this.state.imgsTaken.length > 0 ?
            <div>
              <ColoredButton
                style={{ marginRight: '5px' }}
                color="red"
                responsive
                label="Clear"
                onClick={this.handleClearPhotos}
              />
              <ColoredButton
                color="blue"
                responsive
                label="Submit"
                onClick={this.handlePhotoSubmit}
              />
            </div> : null }
          {this.state.errorMessage ? <h3
            className="errorMsg" style={{ color: 'red', textAlign: 'center', fontSize: '20px' }}
          >Please take a photo before submitting</h3> : null}
        </div>
      </div>
    </Dialog>);
  }
}

DeliveredModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  lrrpCreate: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  uploadDocument: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  leadCertNumber: PropTypes.number,
  task: TaskType.isRequired,
  serverErrors: PropTypes.shape({}),
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.arrayOf(PropTypes.string),
  }),
};

DeliveredModal.defaultProps = { active: false };

export default connect(
  state => ({ errors: state.walkthroughs.uploadError }),
  {
    clearValidation,
    clearValidationErrors,
    lrrpCreate,
    updatePhaseTask,
    uploadDocument,
  },
)(DeliveredModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/DeliveredModal/index.jsx